<script>
/* import { tableData } from './data-advance' */
import { mapActions } from 'vuex'
import moment from 'moment/moment'

export default {
	data() {
		return {
			title: this.$t('financing.plural'),
			items: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 20,
			pageOptions: [20, 50, 100, 200],
			filter: null,
			filterOn: [],
			sortBy: '',
			sortDesc: false,
			fields: [
        { 
          label: this.$t('financing.table.application'), 
          key:'_id'
        },
        { 
          label: this.$t('financing.table.rate'), 
          key:'rate',
          formatter: (val, name, row) => {
            var rate = val ? val.$numberDecimal : 0,
              symbol = !row.currency ? '' : row.currency.symbol
            return row.fixed ? this.$options.filters.currency(rate, symbol, symbol == '¥' ? 0 : 2) : this.$options.filters.percent(rate / 100)
          }
        },
        { 
          label: this.$t('financing.table.amount_earned'), 
          key:'amount_earned',
          formatter: (val, name, row) => {
            var rate = val ? val.$numberDecimal : 0,
              symbol = !row.currency ? '' : row.currency.symbol
            return this.$options.filters.currency(rate, symbol, symbol == '¥' ? 0 : 2)
          }
        },
        { label: this.$t('financing.table.date_created'), key:'date_created', formatter: (val) => {
          return moment(val).format('YYYY-MM-DD')
        }}
      ],
      isBusy:false
		}
	},
	computed: {
		rows() {
			return this.totalRows
		},
	},
	mounted() {
    this.fetchData()
	},
	methods: {
		...mapActions('finance', ['pagination']),
		onFiltered(filteredItems) {
			// Trigger pagination to update the number of buttons/pages due to filtering
			this.totalRows = filteredItems.length
			this.currentPage = 1
    },
    async fetchData() {
      this.toggleBusy()

      await this.pagination({
        limit:this.perPage,
        start:this.currentPage,
      })
        .then(res => {
          this.totalRows = parseInt(res.data.total, 10)
          this.items = res.data.data
          this.toggleBusy()
        })
    },
    toggleBusy() {
      this.isBusy = !this.isBusy
    }
  },
  filters: {
    formatdate: function (value) {
      if (!value) return ''

      return moment(value).format('YYYY-MM-DD')
    }
  },
  watch: {
    currentPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    perPage: {
      handler: function() {
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    },
    filter: {
      handler: function() {
        console.log(this.filter)
        this.fetchData().catch(error => {
          console.error(error)
        })
      }
    }
  }
}
</script>
<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body p-0 pb-2">
          <h6 class="card-title card-header header-title border-bottom py-2 px-1 mb-0">MY EARNINGS</h6>
          <!-- Table -->
          <div class="table-responsive mb-0">
            <b-table
              :busy="isBusy"
              :items="items"
              :fields="fields"
              responsive="lg"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              :show-empty="true"
              small
            >

              <template v-slot:cell(_id)="row">
                <div class="font-weight-bold">{{row.item.application_id ? row.item.application_id.candidate_id.full_name : 'N/A'}}</div>
                <div class="text-muted">Title: {{row.item.application_id ? row.item.application_id.job_id.title : 'N/A'}}</div>
              </template>

              <template v-slot:table-busy>
                <div class="text-center text-primary my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div
                class="dataTables_paginate paging_simple_numbers float-right"
              >
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="rows"
                    :per-page="perPage"
                  ></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
